import { render } from "./PerCircle.vue?vue&type=template&id=0e50678a&scoped=true"
import script from "./PerCircle.vue?vue&type=script&lang=js"
export * from "./PerCircle.vue?vue&type=script&lang=js"

import "./PerCircle.vue?vue&type=style&index=0&id=0e50678a&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e50678a"]])

export default __exports__